import { useEffect } from 'react';
import { useSyncWalletAddress } from '@/hooks/useSyncWalletAddress';
import { useSyncTonWalletAddress } from '@/hooks/useSyncTonWalletAddress';
import { useClient } from '@ywwwtseng/react-kit';

export function SyncWalletAddress({ children }: { children: React.ReactNode }) {
  const { query } = useClient();
  useSyncWalletAddress();
  useSyncTonWalletAddress();

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        void query('me');
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return children;
}
